/* This file is generated by scripts/generate-registry.ts. */
import type { ToolRegistryEntry } from "@local-tools/tool-sdk";

export const toolRegistry = [
  {
    manifest: {
      "id": "jwt-decoder",
      "route": "/jwt-decoder",
      "title": "JWT Decoder",
      "description": "Inspect a JSON Web Token's header and claims. Everything is decoded on your device.",
      "category": "developer tools",
      "keywords": [
        "jwt",
        "json web token",
        "bearer",
        "claims",
        "token"
      ],
      "toolVersion": "0.1.0",
      "sdkVersion": "1",
      "accepts": [
        "text/plain"
      ],
      "emits": [
        "application/json"
      ],
      "capabilities": [],
      "network": "denied",
      "storage": "denied",
      "offline": true,
      "maxInputBytes": 1048576,
      "stability": "beta"
    },
    load: () => import("@local-tools/jwt-decoder/ui")
  }
] satisfies ToolRegistryEntry[];
